import cn from 'classnames'

import { TabModeEnum } from '../interface'
import { useTabsSelectSaleAnalytics } from '../TabsSelectSaleAnalytics'

interface TabListProps {
  className?: string
  borderBottomClassName?: string
  id?: string
  children: React.ReactNode
}

export const TabList = ({
  className,
  borderBottomClassName,
  id,
  children,
}: TabListProps) => {
  const { mode } = useTabsSelectSaleAnalytics()

  return (
    <div
      id={id}
      className={cn(
        'select-none overflow-x-scroll scrollbar-none scrollbar-none::-webkit-scrollbar mb-[20px]',
        className
      )}
    >
      <div
        className={cn(
          'text-[14px] text-secondary dark:text-dark-10 font-light space-x-[15px] flex',
          {
            'mobile:ml-[0px] ': mode === TabModeEnum.BOX,
          }
        )}
      >
        {children}
      </div>
      <div
        className={cn(
          'absolute w-full h-[1px] bottom-[1px] bg-gray-3 dark:bg-purple z-0',
          {
            hidden: mode === TabModeEnum.BOX,
          },
          borderBottomClassName
        )}
      />
    </div>
  )
}
